<template>
  <div class="detail-box">
    <div
      :class="['header', rightScrollTop > 0 ? 'fixed-header' : '']"
      :style="rightScrollTop > 0 ? { width: `${offsetWidth}px`, top: `${offsetTop}px` } : {}"
    >
      <div class="top-line"></div>
      <div class="header-container">
        <div class="left-option">
          <div class="icon-item" @click="handleItem('back')">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="icon-item" @click="handleItem('detail')">
            <i class="el-icon-full-screen"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="inner-content">
      <div class="wiki-detail-body">
        <!-- 文章标题 -->
        <detail-title :detail="detail"></detail-title>
        <!-- 文章描述 -->
        <detail-desc :detail="detail" @refresh="refresh"></detail-desc>
        <!-- 正文内容 -->
        <template v-if="detail && detail.id > 0">
          <!-- 老编辑器 -->
          <detail-content v-if="detail.editor_type == 0" :content-data="detail" />
          <!-- 新编辑器 -->
          <detail-json-content v-if="detail.editor_type == 1" :content-data="detail" />
          <!-- 图鉴编辑器 -->
          <book-content
            v-else-if="detail.editor_type == 2"
            mode="view"
            :content-data="formatContentData(detail.content_json)"
          />
        </template>

        <!-- 正文创建日期、举报、点赞、收藏 -->
        <detail-footer :detail="detail" @refresh="refresh"></detail-footer>
      </div>
      <!-- 添加评论\评论列表 -->
      <detail-comment
        :detail="detail"
        :user="user"
        :list="list"
        :pagination="pagination"
        :loadCommentStatus="loadCommentStatus"
        @getCommentList="getCommentList"
        @refresh="refresh"
        @setLoading="setLoading"
        style="padding: 0;"
      ></detail-comment>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// components
import DetailTitle from "@/views/wiki/detail/components/detailTitle";
import DetailDesc from "@/views/wiki/detail/components/detailDesc";
// import DetailUser from "@/views/wiki/detail/components/detailUser";
import DetailContributor from "@/views/wiki/detail/components/detailContributor";
import DetailContent from "@/views/wiki/detail/components/detailContent";
import DetailJsonContent from "@/views/wiki/detail/components/detailJsonContent";
import DetailFooter from "@/views/wiki/detail/components/detailFooter";
import DetailComment from "@/views/wiki/detail/components/detailComment";
import BookContent from "@/views/editor/wiki-editor/illustrated-book/BookContent";
// api
import { apiContentDetail } from "@/api/contentApi";
import { apiCommentList } from "@/api/commentApi";
// plugins
import eventBus from "@/plugins/eventBus";
import { getJumpWikiDetailUrl } from "@/plugins/util";

export default {
  name: "detailBox",
  props: {
    isShowDetailBox: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DetailTitle,
    DetailDesc,
    // DetailUser,
    DetailContributor,
    DetailContent,
    DetailJsonContent,
    DetailFooter,
    DetailComment,
    BookContent
  },
  data() {
    return {
      loading: false,
      prevRoute: null,
      hasHistory: true,

      // 详情
      isSSRGetData: false,
      detail: {
        id: 0,
        user: { uid: 0 }
      },
      user: {
        avatar: "",
        uid: 0,
        username: "",
        is_followed: 0
      },
      // 评论列表
      list: [],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      loadCommentStatus: "",
      rightScrollTop: 0,
      offsetTop: 0,
      offsetWidth: 0
    };
  },
  computed: {
    ...mapGetters(["loginUser", "loginUid", "gameInfo"])
  },
  mounted() {
    eventBus.$on("getDetail", this.getDetail);
    const rightScroll = document.getElementById("rightScroll");
    window.addEventListener("scroll", this.handleScroll, false);
    if (rightScroll) {
      rightScroll.addEventListener("scroll", this.handleScroll, false);
    }
  },
  activated() {},
  beforeDestroy() {
    const rightScroll = document.getElementById("rightScroll");
    window.removeEventListener("scroll", this.handleScroll, false);
    eventBus.$off("getDetail");
    if (rightScroll) {
      rightScroll.removeEventListener("scroll", this.handleScroll, false);
    }
  },
  methods: {
    // 设置loading
    setLoading(loading) {
      this.loading = loading;
    },
    // 刷新详情
    refresh(detail, user) {
      if (detail) {
        this.$set(this, "detail", detail);
      }
      if (user) {
        this.$set(this, "user", user);
      }
    },
    // 格式化图鉴数据
    formatContentData(content_json) {
      try {
        const contentJson = JSON.parse(content_json || "");
        if (Array.isArray(contentJson)) {
          return contentJson;
        }
        return contentJson.children;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取文章详情
    async getDetail(id) {
      if (!id) {
        return;
      }
      this.detail = {
        id: 0,
        user: { uid: 0 }
      };
      this.list = [];
      await apiContentDetail({ id })
        .then(async res => {
          if (res.code == 0) {
            this.detail = res.data;
            const routeMeta = this.$route.meta;
            // 文章关联weiki和当前wiki不匹配，返回对应wiki详情；
            if (!routeMeta.noWikiRoute && this.detail.game.alias != this.gameInfo.alias) {
              const url = getJumpWikiDetailUrl(this.detail.game.alias, this.detail.game.id, id);
              window.location.replace(url);
              return;
            }
            this.user = this.detail.user;
            // eventBus.$emit('setDetailContent', res.data);
            await this.getCommentList();
          }
        })
        .catch(err => {
          // 文章审核中
          if (err && err.code === 100002) {
            this.detail = {
              isUnderReview: 1
            };
            return;
          }
          // 文章禁用
          if (err && err.code === 100010) {
            this.detail = {
              audit_state: -1
            };
            return;
          }
          if (err && err.code == 1002 && err.msg == "文章不存在: record not found") {
            // 没有文章信息，重定向到404
            this.$router.replace("/404");
          }
        });
    },
    // 获取评论
    async getCommentList(type) {
      let { id } = this.detail;
      if (!id || (id && id.toString().includes("_"))) return;
      if (type == "refresh") {
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        };
        this.list = [];
      }
      let { pagination } = this;
      if (pagination.page_no >= pagination.page_total) {
        this.loadCommentStatus = "end";
        return;
      }

      ++pagination.page_no;
      let params = {
        ...pagination,
        content_id: Number(id)
      };
      this.loadCommentStatus = "loading";
      await apiCommentList(params)
        .then(res => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data);
            this.pagination = res.meta.pagination;
            // if (this.list.length > 2 && this.pagination.page_no == 1) {
            // }
          }
        })
        .finally(_ => {
          this.loadCommentStatus = "";
        });
    },
    handleItem(type) {
      if (type === "back") {
        eventBus.$emit("setDetailBoxVisible", false);
        eventBus.$emit("setCataVisible", false);
        eventBus.$emit("setCataList", []);
      } else if (type === "detail") {
        if (!this.detail.id) {
          return;
        }
        this.$router.push(`/${this.detail.id}.html`);
      }
    },
    // 监听父级滚动
    handleScroll() {
      const { name } = this.$route;
      const rightScroll = document.getElementById("rightScroll");
      const winScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const mainBox = document.getElementById("wikiMainBox");
      const offsetTop = mainBox && mainBox.offsetTop + (name === "wikiNew" ? 142 : 82);
      const offsetWidth = (rightScroll && rightScroll.offsetWidth) || 0;
      this.rightScrollTop = (rightScroll && rightScroll.scrollTop) || 0;
      this.offsetTop = offsetTop - winScrollTop;
      this.offsetWidth = offsetWidth - 14;
    }
  }
};
</script>
<style lang="less" scoped>
.detail-box {
  z-index: 1;
  width: 100%;
  padding: 4px;
  padding-top: 0;
  .header {
    height: 40px;
    transition: width ease 0.2s;
    .top-line {
      width: 100%;
      height: 4px;
      background-color: #fff;
    }
    .header-container {
      display: flex;
      align-items: center;
      height: 36px;
      padding: 0 10px;
      border-radius: 4px;
      background-color: #e3e6ee;
      box-sizing: border-box;
      .left-option {
        display: flex;
        align-items: center;
        .icon-item {
          width: 28px;
          height: 28px;
          border-radius: 6px;
          background-color: #fff;
          cursor: pointer;
          line-height: 28px;
          text-align: center;
          color: #2e3a58;
          font-size: 18px;
          font-weight: bold;
          &:not(:last-child) {
            margin-right: 10px;
          }
        }
      }
    }
    &.fixed-header {
      z-index: 90;
      position: fixed;
    }
  }
  .inner-content {
    padding: 20px;
  }
}
</style>
